import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { } from '../Features/SmsGatewaysdata';
import { RootState, AppDispatch } from '../Appstore/store';
import { setIsLoading } from '../Features/loadingSlice';
import { formatDate } from '../helper';
import { GetallSmsCampaignWiseReport } from '../Features/reports/SmsCampaignWiseReports';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { GetallSmsCampaignWiseReportDawnlaod } from '../Features/reports/Smscampaignwisereportsdawnload';
import { RenderPaginationButtons } from './Paginations';
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { SmsCampaignWiseReport } from '../Features/reports/SmsCampaignWiseReports';
import { GetallSmsCampaign } from '../Features/smscampaign/Smscampaign';
import { Dropdown } from 'react-bootstrap';
import { FaFile } from 'react-icons/fa';
import { BsFiletypeDoc, BsFiletypeDocx, BsFiletypePdf, BsFiletypeXls, BsFiletypeXlsx } from 'react-icons/bs';
import { isJSONString } from '../User/Pages/Chatbox/ChatBox';
import { FiDownload } from 'react-icons/fi';
import { saveAs } from "file-saver";
import ReactSelect, { components } from "react-select";
import axiosInstance from '../api/axiosInstance';
import { AxiosResponse } from 'axios';

function Viewsmscampaignwisereports() {
    const [dateRangeText, setDateRangeText] = useState<string>("Date Filter");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const limit = 10;
    const [isExporting, setIsExporting] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const { id }: any = useParams();
    const navigate = useNavigate();

    const { smscampaignwisereportdata, info, loading, error } = useSelector((state: RootState) => state.smscampaignwisereports);
    const recordreport: SmsCampaignWiseReport | any = smscampaignwisereportdata || [];

    const [smsGatewayName, setsmsGatewayName] = useState("");
    const [Messagetype, setMessagetype] = useState("");
    const [from, setfrom] = useState('');
    const [to, setto] = useState('');
    const [status, setStatus] = useState<number[]>([]);
    const [direction, setdirection] = useState("");
    const [retrysmsid, setretrysmsid] = useState("")
    const [errorcode, seterrorcode] = useState("")
    const [fromdate, setfromdate] = useState("")
    const [todate, settodate] = useState("")
    const [username, setusername] = useState("")
    const [useremail, setuseremail] = useState("")
    const [userrole, setuserrole] = useState("")

    const statusOption = [
        { value: 0, label: "Pending" },
        { value: 1, label: "Sent" },
        { value: 2, label: "Delivered" },
        { value: 3, label: "Undelivered" },
        { value: 4, label: "Failed" },
        { value: 5, label: "Delivery Unknown" },
        { value: 6, label: "Delivery Unconfirmed" },
        { value: 7, label: "Unknown Gateway" },
    ];
    const [users, setUsers] = useState<{ value: number; label: string }[]>([]);
    const [selectUser, setSelectUser] = useState<{ value: number; label: string }[]>([]);
    const [UserSearch, setUserSearch] = useState("");
    const [isUserSearch, setIsUserSearch] = useState(false);
    const [UserInfo, setUserInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [UserPgae, setUserPage] = useState(1);

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };

    const [dateRange, setDateRange] = useState({ from: "", to: "", });

    const formatDateDateFilter = (date: string): string => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const GetUserList = () => {
        axiosInstance.get(`/api/admin/users?limit=50&search=${UserSearch}&page=${UserPgae}`)
            .then((resp: AxiosResponse) => {
                let data = isUserSearch ?
                    resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []
                    : [...users, ...resp.data?.data?.map((item: any) => ({ value: item?.id, label: item?.name })) || []]
                setUsers(data);
                setUserPage(resp.data?.info?.current_page || 1);
                setUserInfo(resp?.data?.info);
                setIsUserSearch(false);
            }).catch(() => { setIsUserSearch(false); });
    };

    useEffect(() => {
        GetUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [UserPgae])

    useEffect(() => {
        if (isUserSearch) GetUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [UserSearch])

    useEffect(() => {
        if (info) setCurrentPage(info?.current_page as number);
    }, [info])


    const applyDateFilter = () => {
        if (!dateRange.from || !dateRange.to) {
            return;
        }

        const formattedFrom = formatDateDateFilter(dateRange.from);
        const formattedTo = formatDateDateFilter(dateRange.to);
        setfromdate(formattedFrom)
        settodate(formattedTo)
        setCurrentPage(1)

        setDateRangeText(`${formattedFrom} - ${formattedTo}`);

        dispatch(GetallSmsCampaignWiseReport({
            id: id,  // Ensure `id` is passed (or set it appropriately)
            sms_gateway_name: smsGatewayName,
            message_type: Messagetype,
            from: from,
            to: to,
            status: status?.join(","),
            direction: direction,
            retry_sms_id: retrysmsid ? parseInt(retrysmsid, 10) : undefined,
            error_code: errorcode,
            from_date: formattedFrom,
            to_date: formattedTo,
            username: username,
            useremail: useremail,
            userrole: userrole,
            page: currentPage,
            limit: limit,
            user_id: selectUser.map(item => item.value).join(","),
            sort_field: "", // Add the appropriate field for sorting
        }));
    };

    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" });
        setDateRangeText("Date Filter")
        setfromdate("")
        settodate('')
        setCurrentPage(1)
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(GetallSmsCampaignWiseReport({
                id: id,
                sms_gateway_name: smsGatewayName,
                message_type: Messagetype,
                from: from,
                to: to,
                status: status?.join(","),
                direction: direction,
                retry_sms_id: retrysmsid ? parseInt(retrysmsid, 10) : undefined,
                error_code: errorcode,
                from_date: fromdate,
                to_date: todate,
                username: username,
                useremail: useremail,
                userrole: userrole,
                page: currentPage,
                limit: limit,
                user_id: selectUser.map(item => item.value).join(","),
                sort_field: "" // Provide an appropriate value
            }));
            setIsLoading(true)
        }, 0);

        return () => clearTimeout(timer);
    }, [dispatch, currentPage, limit, id]);

    useEffect(() => {
        const debFN = setTimeout(() => {
            dispatch(GetallSmsCampaignWiseReport({
                id: id,
                sms_gateway_name: smsGatewayName,
                message_type: Messagetype,
                from: from,
                to: to,
                status: status?.join(","),
                direction: direction,
                retry_sms_id: retrysmsid ? parseInt(retrysmsid, 10) : undefined,
                error_code: errorcode,
                from_date: fromdate,
                to_date: todate,
                username: username,
                useremail: useremail,
                userrole: userrole,
                page: 1,
                limit: limit,
                user_id: selectUser.map(item => item.value).join(","),
                sort_field: "" // Provide an appropriate value
            }));
        }, 500);

        return () => clearTimeout(debFN);
    }, [smsGatewayName, Messagetype, from, to, status, direction, retrysmsid, errorcode, fromdate, todate, username, useremail, userrole, dateRangeText, selectUser]);

    const handleDownload = () => {
        const formattedFrom = formatDateDateFilter(dateRange.from);
        const formattedTo = formatDateDateFilter(dateRange.to);
        setIsExporting(true);
        dispatch(GetallSmsCampaignWiseReportDawnlaod({
            id: id,
            sms_gateway_name: smsGatewayName,
            message_type: Messagetype,
            from: from,
            to: to,
            status: status?.join(","),
            direction: direction,
            retry_sms_id: retrysmsid ? parseInt(retrysmsid, 10) : undefined,
            error_code: errorcode,
            from_date: fromdate || "",
            to_date: todate || "",
            username: username,
            useremail: useremail,
            userrole: userrole,
            page: currentPage,
            limit: limit,
            user_id: selectUser.map(item => item.value).join(","),
            sort_field: "" // Provide an
        }))
            .then((response) => {
                if (response.meta.requestStatus === 'fulfilled' && response.payload instanceof Blob) {
                    const blob = response.payload;

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Sms-Campaign-Wise-Report_${new Date().toISOString()}.xlsx`;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setIsExporting(false);;
                }, 500);
            });
    };

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setCurrentPage(page);
        }
    };

    const handlebackbutton = () => {
        navigate(-1);
        dispatch(GetallSmsCampaign({ search: '', page: 1, limit: 10 }))
    }

    const handleClearSearchFilter = () => {
        setSelectUser([]);
        setsmsGatewayName('');
        setfrom("");
        setto('')
        setStatus([]);
        setMessagetype("");
        setdirection('');
        setusername("");
        setuseremail("");
        setuserrole("");
        setretrysmsid("")
        seterrorcode("")
        clearDateFilter()
    };

    const downloadMedia = async (imgUrl: string) => {
        fetch(imgUrl)
            .then((response) => response.blob())
            .then((blob) => {
                saveAs(blob, imgUrl.split("/").pop());
            })
            .catch(() => { });
    };

    if (error) {
        <div>No found data</div>
    }

    return (

        <div className="wrapper">
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="card mt-4">
                            <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                                <div className='d-xl-flex mt-xl-0 mt-2 justify-content-between w-100'>
                                    <h2 className="mb-0 fs-3">SMS Campaign Wise Reports</h2>
                                    <div className='d-md-flex justify-content-between mt-3'>
                                        <div className='d-flex'>
                                            <button onClick={handleClearSearchFilter} className='d-md-block d-none width-reports-header-buttons mt-md-0 mt-2 btn btn-secondary d-flex align-items-center' style={{ width: 122 }}>
                                                <MdClear className='fs-5' />
                                                Clear Filter
                                            </button>
                                            <button
                                                onClick={handleDownload}
                                                className='d-md-block d-none width-reports-header-buttons btn btn-info bg-success ms-2 text-white mt-md-0 mt-2 d-flex align-items-center fw-semibold'
                                                disabled={isExporting}
                                            >
                                                <BiExport className='fs-5' />
                                                {isExporting ? 'Exporting...' : `Export `}
                                            </button>
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    className="fw-semibold ms-md-2"
                                                    variant="primary"
                                                    id="dropdown-basic"
                                                >
                                                    {dateRangeText}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="p-3 Date-Filter-Menu">
                                                    <div className="d-flex flex-column">
                                                        <label className="mb-2 fw-semibold">From</label>
                                                        <input
                                                            type="date"
                                                            name="from"
                                                            value={dateRange.from}
                                                            onChange={handleDateChange}
                                                            className="form-control mb-3"
                                                        />

                                                        <label className="mb-2 fw-semibold">To</label>
                                                        <input
                                                            type="date"
                                                            name="to"
                                                            value={dateRange.to}
                                                            onChange={handleDateChange}
                                                            className="form-control mb-3"
                                                        />

                                                        <div className="d-flex justify-content-between">
                                                            <button className="btn btn-primary w-100 me-1" onClick={applyDateFilter}>
                                                                Apply
                                                            </button>

                                                            <button className="btn btn-secondary w-100 ms-1" onClick={clearDateFilter}>
                                                                Clear
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Dropdown.Menu>
                                            </Dropdown>

                                            <div>
                                                <button onClick={handlebackbutton} className='btn btn-info ms-md-2 mt-md-0 text-white d-flex align-items-center fw-semibold'>
                                                    <IoMdArrowRoundBack /> Back
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='d-flex d-md-none flex-wrap justify-content-between'>
                                    <div className=''>
                                        <button onClick={handleClearSearchFilter} className=' mt-md-0 mt-3 btn btn-secondary d-flex align-items-center justify-content-center' style={{ width: 122 }}>
                                            <MdClear className='fs-5' />
                                            Clear Filter
                                        </button>
                                    </div>
                                    <div className=''>
                                        <button
                                            onClick={handleDownload}
                                            className=' btn btn-info bg-success ms-2 text-white mt-md-0 mt-3 d-flex align-items-center fw-semibold justify-content-center'
                                            disabled={isExporting}
                                        >
                                            <BiExport className='fs-5' />
                                            {isExporting ? 'Exporting...' : `Export `}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border-start-0 border-end-0 p-0">
                                <>
                                    <div className='table-responsive' style={{ minHeight: 500 }}>
                                        <table className="table table-hover table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 200, minWidth: 200 }}>SR No</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>Message Type</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>From Number</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>To Number</th>
                                                    <th style={{ minWidth: 350 }}>User</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>User Role</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>Direction</th>
                                                    <th style={{ width: 350, minWidth: 350 }}>Media</th>
                                                    <th style={{ width: 350, minWidth: 350 }}>Message</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>Status</th>
                                                    <th style={{ width: 250 }}>Sms Gateway Name</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>Error Code</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>Error Message</th>
                                                    <th style={{ width: 200, minWidth: 200 }}>CreatedAt</th>
                                                </tr>
                                                <tr>
                                                    <th className='ps-3'></th>
                                                    <th>
                                                        <select
                                                            onChange={(e) => setMessagetype(e.target.value)}
                                                            className="form-control"
                                                            value={Messagetype}
                                                        >
                                                            <option value="">All</option>
                                                            <option value="Individual">Individual</option>
                                                            <option value="Broadcast">Broadcast</option>
                                                        </select>
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search From Number"
                                                            onChange={(e) => setfrom(e.target.value.trim())}
                                                            value={from}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search To Number"
                                                            onChange={(e) => setto(e.target.value.trim())}
                                                            value={to}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <ReactSelect
                                                            name="smscampuser"
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            options={users}
                                                            filterOption={() => true}
                                                            className='shadow-none'
                                                            value={selectUser!}
                                                            onChange={(e) => {
                                                                setSelectUser(e as { value: number, label: string }[]);
                                                            }}
                                                            isClearable
                                                            onInputChange={(inputValue) => {
                                                                setUserPage(1)
                                                                setIsUserSearch(true);
                                                                setUserSearch(inputValue)
                                                            }}
                                                            placeholder="Search and select user"
                                                            classNamePrefix="select"
                                                            styles={{
                                                            }}
                                                            components={{
                                                                IndicatorSeparator: () => null,
                                                                DropdownIndicator: () => null,
                                                                MenuList: (props) => (
                                                                    <components.MenuList  {...props}>
                                                                        {props.children}
                                                                        {UserInfo?.total_page! > UserPgae ? <button className='btn btn-secondary w-100' onClick={() => setUserPage(p => p + 1)}>Load more</button> : null}
                                                                    </components.MenuList >
                                                                ),
                                                            }}
                                                        />
                                                    </th>
                                                    <th></th>
                                                    <th>
                                                        <select
                                                            onChange={(e) => setdirection(e.target.value)}
                                                            className="form-control"
                                                            value={direction}
                                                        >
                                                            <option value="">All</option>
                                                            <option value="Outbound">Outbound</option>
                                                            <option value="Inbound">Inbound</option>
                                                        </select>
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th>
                                                        <ReactSelect
                                                            name="status"
                                                            isMulti={true}
                                                            isSearchable={true}
                                                            options={statusOption}
                                                            className='shadow-none'
                                                            value={statusOption.filter((item) => status.includes(item.value))!}
                                                            onChange={(e) => setStatus(e.map((item) => item.value))}
                                                            isClearable
                                                            placeholder="Search and select status"
                                                            classNamePrefix="select"
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search SMS Gateway Name"
                                                            onChange={(e) => setsmsGatewayName(e.target.value.trim())}
                                                            value={smsGatewayName}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                    <th>
                                                        <input
                                                            type="text"
                                                            placeholder="Search Error Code"
                                                            onChange={(e) => seterrorcode(e.target.value.trim())}
                                                            value={errorcode}
                                                            className="form-control"
                                                        />
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr><td colSpan={16} height={100}><div className="text-center"><div className="loader"></div></div></td></tr>
                                                ) : !smscampaignwisereportdata || smscampaignwisereportdata.length === 0 ? (
                                                    <tr><td colSpan={16} height={50}><div className="text-center"><p className='mb-0 fs-5 fw-semibold'>No data found</p></div></td></tr>
                                                ) : (
                                                    recordreport.map((item: any, i: number) => (
                                                        <tr>
                                                            <td>{i + 1 + (currentPage - 1) * 10}</td>
                                                            <td>{item?.message_type || " - "}</td>
                                                            <td>{item?.from || " - "}</td>
                                                            <td>{item?.to || " - "}</td>
                                                            <td>
                                                                <p className="mb-0">{item?.user?.name}</p>
                                                                <p className="mb-0">
                                                                    <small>{item?.user?.email}</small>
                                                                </p>
                                                            </td>
                                                            <td>{item?.user?.role === 1 ? "Agent" : item?.user?.role === 2 ? "Monitor" : " - "}</td>

                                                            <td>{item?.direction || " - "}</td>
                                                            <td className="text-center">
                                                                <div
                                                                    className={`d-flex justify-content-center px-3 gap-2 flex-wrap`}
                                                                >
                                                                    {(!item?.media_url || JSON.parse(item?.media_url).length === 0) ? (
                                                                        <p className="mb-0">-</p>
                                                                    ) : (
                                                                        isJSONString(item?.media_url) &&
                                                                        JSON.parse(item?.media_url).map(
                                                                            (
                                                                                item: { media_url: string; content_type: string },
                                                                                i: number
                                                                            ) => {
                                                                                if (item?.content_type?.startsWith("image/"))
                                                                                    return (
                                                                                        <div
                                                                                            className="showImages bg-dark d-block"
                                                                                            key={i}
                                                                                            style={{ height: 75, width: 75 }}
                                                                                        >
                                                                                            <FiDownload
                                                                                                color="black"
                                                                                                className="my-1 removeImageBtn p-1"
                                                                                                style={{ height: 25, width: 25 }}
                                                                                                onClick={() =>
                                                                                                    downloadMedia(item?.media_url)
                                                                                                }
                                                                                            />
                                                                                            <img
                                                                                                style={{ width: "100%", height: "100%" }}
                                                                                                src={item?.media_url}
                                                                                                alt="img"
                                                                                                className="shadow-none object-fit-contain"
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                                else
                                                                                    return (
                                                                                        <div
                                                                                            className={`showImages bg-dark overflow-hidden`}
                                                                                            style={{ height: 75, width: 75 }}
                                                                                            key={i}
                                                                                        >
                                                                                            <FiDownload

                                                                                                color="black"
                                                                                                className="my-1 removeImageBtn"
                                                                                                onClick={() =>
                                                                                                    downloadMedia(item?.media_url)
                                                                                                }
                                                                                            />
                                                                                            <div className="w-100 h-100 d-flex flex-column justify-content-between">
                                                                                                <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                                                                                    {item?.content_type ===
                                                                                                        "application/vnd.ms-excel" ? (
                                                                                                        <BsFiletypeXls
                                                                                                            className="w-100 text-success"
                                                                                                            style={{ height: 35 }}
                                                                                                        />
                                                                                                    ) : item?.content_type ===
                                                                                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                                                                                                        <BsFiletypeXlsx
                                                                                                            className="w-100 text-success"
                                                                                                            style={{ height: 35 }}
                                                                                                        />
                                                                                                    ) : item?.content_type ===
                                                                                                        "application/msword" ? (
                                                                                                        <BsFiletypeDoc
                                                                                                            className="w-100 text-primary"
                                                                                                            style={{ height: 35 }}
                                                                                                        />
                                                                                                    ) : item?.content_type ===
                                                                                                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                                                                                        <BsFiletypeDocx
                                                                                                            className="w-100 text-primary"
                                                                                                            style={{ height: 35 }}
                                                                                                        />
                                                                                                    ) : item?.content_type ===
                                                                                                        "application/pdf" ? (
                                                                                                        <BsFiletypePdf
                                                                                                            className="w-100 text-danger"
                                                                                                            style={{ height: 35 }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <FaFile
                                                                                                            className="w-100"
                                                                                                            style={{ height: 35 }}
                                                                                                        />
                                                                                                    )}
                                                                                                </div>
                                                                                                <p
                                                                                                    className="mb-2 fs-11 text-center"
                                                                                                    style={{ fontSize: 11 }}
                                                                                                >
                                                                                                    {/* {item?.name} */}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                            }
                                                                        )
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td style={{ maxWidth: 500, textWrap: "balance", overflow: "hidden" }}>{item?.message || " - "}</td>
                                                            <td className={`text-center ${item?.status === 0 ? 'text-warning fw-bold' :
                                                                item?.status === 1 ? 'text-success fw-bold' :
                                                                    item?.status === 2 ? 'text-success fw-bold' :
                                                                        item?.status === 3 ? 'text-danger fw-bold' :
                                                                            item?.status === 4 ? 'text-danger fw-bold' :
                                                                                item?.status === 5 ? 'text-info fw-bold' :
                                                                                    item?.status === 6 ? 'text-info fw-bold' :
                                                                                        item?.status === 7 ? 'text-secondary fw-bold' :
                                                                                            'text-muted'
                                                                }`}>
                                                                {item.status === 0 ? "Pending" :
                                                                    item.status === 1 ? "Sent" :
                                                                        item.status === 2 ? "Delivered" :
                                                                            item.status === 3 ? "Undelivered" :
                                                                                item.status === 4 ? "Failed" :
                                                                                    item.status === 5 ? "Delivery Unknown" :
                                                                                        item.status === 6 ? "Delivery Unconfirmed" :
                                                                                            item.status === 7 ? "Unknown Gateway" : " - "}
                                                            </td>

                                                            <td>{item?.sms_gateway_name || " - "}</td>
                                                            <td>{item?.error_code || " - "}</td>
                                                            <td>{item?.error_message || " - "}</td>
                                                            <td>{formatDate(item?.createdAt) || " - "}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {!smscampaignwisereportdata || smscampaignwisereportdata.length === 0 ? (
                                        <div></div>
                                    ) : (
                                        <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                            <RenderPaginationButtons
                                                info={info}
                                                currentPage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </div >
    );
}

export default Viewsmscampaignwisereports;
